var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVgaDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1347,
    height: 1345,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1527 -565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2816.5 953.5 2709.72 1522.5 1691.28 1522.5 1584.5 953.5Z",
    stroke: "#000000",
    strokeWidth: 114.583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757 1147.5C1757 1116.3 1781.62 1091 1812 1091 1842.38 1091 1867 1116.3 1867 1147.5 1867 1178.7 1842.38 1204 1812 1204 1781.62 1204 1757 1178.7 1757 1147.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2145 1147.5C2145 1116.3 2169.62 1091 2200 1091 2230.38 1091 2255 1116.3 2255 1147.5 2255 1178.7 2230.38 1204 2200 1204 2169.62 1204 2145 1178.7 2145 1147.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2533 1148.5C2533 1117.3 2557.62 1092 2588 1092 2618.38 1092 2643 1117.3 2643 1148.5 2643 1179.7 2618.38 1205 2588 1205 2557.62 1205 2533 1179.7 2533 1148.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2035 1327.5C2035 1296.3 2059.62 1271 2090 1271 2120.38 1271 2145 1296.3 2145 1327.5 2145 1358.7 2120.38 1384 2090 1384 2059.62 1384 2035 1358.7 2035 1327.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815 1327.5C1815 1296.3 1839.62 1271 1870 1271 1900.38 1271 1925 1296.3 1925 1327.5 1925 1358.7 1900.38 1384 1870 1384 1839.62 1384 1815 1358.7 1815 1327.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2255 1327.5C2255 1296.3 2279.62 1271 2310 1271 2340.38 1271 2365 1296.3 2365 1327.5 2365 1358.7 2340.38 1384 2310 1384 2279.62 1384 2255 1358.7 2255 1327.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475 1327.5C2475 1296.3 2499.62 1271 2530 1271 2560.38 1271 2585 1296.3 2585 1327.5 2585 1358.7 2560.38 1384 2530 1384 2499.62 1384 2475 1358.7 2475 1327.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1951 1147.5C1951 1116.3 1975.62 1091 2006 1091 2036.38 1091 2061 1116.3 2061 1147.5 2061 1178.7 2036.38 1204 2006 1204 1975.62 1204 1951 1178.7 1951 1147.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1147.5C2340 1116.3 2364.62 1091 2395 1091 2425.38 1091 2450 1116.3 2450 1147.5 2450 1178.7 2425.38 1204 2395 1204 2364.62 1204 2340 1178.7 2340 1147.5Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgaDark);
export default __webpack_public_path__ + "static/media/vga_dark.8e8cdd2a5b0e485d8e68f401163dfa03.svg";
export { ForwardRef as ReactComponent };